import {
  BarChart3,
  Globe2,
  LayoutTemplate,
  Mail,
  Sparkles,
  Wand2,
} from "lucide-react";

const FEATURES = [
  {
    icon: LayoutTemplate,
    title: "10 conversion-tested offer types",
    description:
      "Lead magnets, webinars, consults, course waitlists, ebooks — each with copy and structure that actually converts.",
  },
  {
    icon: Wand2,
    title: "Visual block editor",
    description:
      "14 section types, multiple variants per section, per-block style overrides. Tweak anything without touching code.",
  },
  {
    icon: Globe2,
    title: "Instant publishing",
    description:
      "One click publishes to your-slug.funnlr.co with HTTPS, fast hosting, and a real CSP. No DNS gymnastics.",
  },
  {
    icon: Mail,
    title: "Lead capture · built in",
    description:
      "Forms post directly into your dashboard. Export to CSV or wire into your existing tools. No third-party form builders.",
  },
  {
    icon: BarChart3,
    title: "Per-funnel analytics",
    description:
      "Pageviews, leads, conversion rate, source attribution. Clean numbers, no vanity dashboards.",
  },
  {
    icon: Sparkles,
    title: "Five pro design templates",
    description:
      "Digital agency, coach, real estate, health, SaaS. Each with its own type, color, and spacing system.",
  },
];

export function Features() {
  return (
    <section
      id="features"
      className="bg-slate-50/70 px-6 py-20 sm:py-28"
    >
      <div className="mx-auto max-w-6xl">
        <div className="max-w-2xl">
          <p
            data-reveal
            className="text-[11px] font-semibold uppercase tracking-[0.18em] text-violet-600"
          >
            What's inside
          </p>
          <h2
            data-reveal
            className="mt-4 font-heading text-[32px] font-bold leading-[1.05] tracking-tight text-slate-900 sm:text-[44px]"
          >
            Everything you need to ship a funnel.{" "}
            <span className="text-gradient-brand">Nothing you don&apos;t.</span>
          </h2>
        </div>

        <div
          data-reveal-stagger
          className="mt-12 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3"
        >
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="group relative flex flex-col gap-3 rounded-2xl border border-slate-200/70 bg-white p-6 transition-colors hover:border-slate-300"
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-violet-50 text-violet-600 ring-1 ring-violet-100">
                <f.icon className="h-4 w-4" />
              </div>
              <h3 className="font-heading text-[15px] font-semibold tracking-tight text-slate-900">
                {f.title}
              </h3>
              <p className="text-[13.5px] leading-relaxed text-slate-500">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
